import React from 'react'
import GoogleMapReact from 'google-map-react';
import { useParams, useLocation } from 'react-router-dom'
import { makeStyles, Typography } from '@material-ui/core';
const IMAGES_BASEPATH = `${process.env.PUBLIC_URL}/images`;


const MARKER_WIDTH = 60;
const MARKER_HEIGHT = 20;

const ROOT_HEIGHT = 425;
const ROOT_WIDTH = 755;

const LEGEND_HEIGHT = 20;
const LEGEND_PADDING_Y = 8;

const MAP_HEIGHT = ROOT_HEIGHT - (LEGEND_HEIGHT + (LEGEND_PADDING_Y * 2));

// A custom hook that builds on useLocation to parse
// the query string for you.
function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const useStyles = makeStyles(theme=> ({
    root: {
        width: ROOT_WIDTH,
        height: ROOT_HEIGHT,
        position: 'relative',
        fontFamily: ['"LL Circular Pro"', 'Arial', 'Helvetica', 'sans-serif'],
    },
    mapWrapper: {
        width: "100%",
        height: MAP_HEIGHT,
    },
    legend: {
        zIndex: 2,
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        height: LEGEND_HEIGHT,
        backgroundColor: '#FFF',
        padding: `${LEGEND_PADDING_Y}px 0px`,
        justifyContent: 'flex-end',
    },
    legendText: {
        fontWeight: 500,
        fontSize: 14,
        marginRight: 5,
    },
    legendStatusIndicator: {
        marginLeft: 15,
    },
    marker: {
        position: 'absolute',
        width: MARKER_WIDTH,
        height: MARKER_HEIGHT,
        left: -MARKER_WIDTH / 2,
        top: -MARKER_HEIGHT / 2,
        // border: '5px solid #f44336',
        borderRadius: 5,
        backgroundColor: 'white',
        textAlign: 'center',
        padding: 5,
        boxShadow: '0px 4px 5px 0px rgba(0,0,0,0.31)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    markerPrice: {
        fontSize: 14,
        fontWeight: 700,
    },
    markerTriangle: {
        display: 'block',
        height: 10,
        width: 10,
        backgroundColor: '#fff',
        position: 'absolute',
        left: 'calc(50% - 5px)',
        bottom: -5,
        boxShadow: '0px 4px 5px 0px rgba(0,0,0,0.31)',
        clipPath: 'polygon(0% 0%, 100% 100%, 0% 100%)',
        transform: 'rotate(-45deg)',
    },
    markerStatusIndicator: {
        marginRight: 5,
        height: '15px',
        width: '15px',
        backgroundColor: '#bbb',
        borderRadius: '50%',
        display: 'inline-block',
    },
    markerStatusIndicatorActive: {
        backgroundColor: '#54d0aa',
    },
    markerStatusIndicatorPending: {
        backgroundColor: '#ffc85a',
    },
    markerStatusIndicatorSold: {
        backgroundColor: '#ff6259',
    },
    markerStatusIndicatorMyHome: {
        backgroundColor: '#000',
    },
    addressPrompt: {
        backgroundColor: '#000',
        borderRadius: 5,
        color: 'white',
        padding: '12px 0px',
        position: 'absolute',
        bottom: 50,
        left: '50%',
        transform: 'translate(-50%, 0)',
        width: 370,
        // fontWeight: 700,
        fontSize: 16,
        textAlign: 'center',
    },
    houseEmoji: {
        width: 18,
        height: 18,
        marginBottom: -2,
    },
}));

const priceFormatter = Intl.NumberFormat('en', { notation: 'compact' });


function Legend() {
    const classes = useStyles();

    return (
        <div
            className={classes.legend}
        >
            <div
                className={`
                    ${classes.legendStatusIndicator}
                    ${classes.markerStatusIndicator}
                    ${classes.markerStatusIndicatorActive}
                `}
            />
            <Typography variant="body2" className={classes.legendText}>Recently listed</Typography>
            <div
                className={`
                    ${classes.legendStatusIndicator}
                    ${classes.markerStatusIndicator}
                    ${classes.markerStatusIndicatorPending}
                `}
            />
            <Typography variant="body2" className={classes.legendText}>Pending</Typography>
            <div
                className={`
                    ${classes.legendStatusIndicator}
                    ${classes.markerStatusIndicator}
                    ${classes.markerStatusIndicatorSold}
                `}
            />
            <Typography variant="body2" className={classes.legendText}>Recently sold</Typography>
        </div>
    )
}



function MyMarker({ price, status }) {
    const classes = useStyles();
    const classNameOverride = classes[`markerStatusIndicator${status}`];
    return (
        <div className={classes.marker}>
            <div className={`${classes.markerStatusIndicator} ${classNameOverride}`}></div>
            <Typography className={classes.markerPrice}>
                {`$${priceFormatter.format(price)}`}
            </Typography>
            <div className={classes.markerTriangle} />
        </div>
    )
}


function AddressPrompt() {
    const classes = useStyles();

    return (
        <div
            className={classes.addressPrompt}
        >
            <img src={`${IMAGES_BASEPATH}/house_1f3e0.png`}
                alt=""
                className={classes.houseEmoji}
            />
            &nbsp;&nbsp;Enter your address to personalize results
        </div>
    );
}


export default function RobinMarketActivityMap() {
    const classes = useStyles();
    const { data } = useParams();
    const query = useQuery();
    const parsedData = data.split(',')
        .map(item => {
            const [status, price, lat, lng] = item.split('|');
            return {
                status,
                price,
                lat: parseFloat(lat, 10),
                lng: parseFloat(lng, 10),
            };
        });
    const handleApiLoaded = (map, maps)=> {
        // console.debug('maps', maps);
        // console.debug('map', map);
        var latlng = parsedData.map(({ lat, lng })=> new maps.LatLng(lat, lng));
        var latlngbounds = new maps.LatLngBounds();
        for (var i = 0; i < latlng.length; i++) {
            latlngbounds.extend(latlng[i]);
        }
        map.fitBounds(latlngbounds);
        maps.event.addListener(map, 'idle', ()=> {
            console.debug('Finished loading everything');
            setTimeout(()=> {
                window.isLoaded = true;
            }, 50);
        });
    }
    return (
        <div className={classes.root} id="templateRoot">
            <div className={classes.mapWrapper}>
                <GoogleMapReact
                    bootstrapURLKeys={{
                        key: process.env.REACT_APP_GOOGLE_API_KEY,
                        region: 'us',
                    }}
                    defaultZoom={10}
                    defaultCenter={[33.78724, -117.85496]}
                    // center={[parsedData[0].lat, parsedData[0].lng]}
                    onGoogleApiLoaded={({ map, maps }) => handleApiLoaded(map, maps)}
                    options={{
                        keyboardShortcuts: false,
                        draggable: false,
                        zoomControl: false,
                        fullscreenControl: false,
                        disableDefaultUI: false,
                        draggableCursor: 'pointer',
                    }}
                >
                    {parsedData.map(({ lat, lng, status, price }, i)=> (
                        <MyMarker
                            key={i}
                            lat={lat}
                            lng={lng}
                            status={status}
                            price={price}
                        />
                    ))}
                </GoogleMapReact>
            </div>
            {query.get('addressPrompt') === 'true' && (
                <AddressPrompt />
            )}
            <Legend />
        </div>
    )
}
